import { Image, Maybe } from '~/jobiqo/types/types';
import { BadgeIcon } from '~/vcl/icons/Badge';
import { BriefcaseIcon } from '~/vcl/icons/Briefcase';
import { CalendarIcon } from '~/vcl/icons/Calendar';
import { ChartIcon } from '~/vcl/icons/Chart';
import { ClockIcon } from '~/vcl/icons/Clock';
import { ConnectionNetworkIcon } from '~/vcl/icons/ConnectionNetwork';
import { CreditCardIcon } from '~/vcl/icons/CreditCard';
import { DownloadIcon } from '~/vcl/icons/Download';
import { EnvelopeIcon } from '~/vcl/icons/Envelope';
import { ExitIcon } from '~/vcl/icons/Exit';
import { ExploreIcon } from '~/vcl/icons/Explore';
import { FiltersIcon } from '~/vcl/icons/Filters';
import { GraduationCapIcon } from '~/vcl/icons/GraduationCap';
import { InfoIcon } from '~/vcl/icons/Info';
import { JobPerFileIcon } from '~/vcl/icons/JobPerFile';
import { JobPerTemplateIcon } from '~/vcl/icons/JobPerTemplate';
import { LaptopAnalyticsIcon } from '~/vcl/icons/LaptopAnalytics';
import { LockIcon } from '~/vcl/icons/Lock';
import { MapMarkerIcon } from '~/vcl/icons/MapMarker';
import { MarkerIcon } from '~/vcl/icons/Marker';
import { NetworkIcon } from '~/vcl/icons/Network';
import { OfficeIcon } from '~/vcl/icons/Office';
import { PaymentIcon } from '~/vcl/icons/Payment';
import { ResumeLockIcon } from '~/vcl/icons/ResumeLock';
import { RocketIcon } from '~/vcl/icons/Rocket';
import { StarIcon } from '~/vcl/icons/Star';
import { VideoGalleryIcon } from '~/vcl/icons/VideoGallery';
import { WeightIcon } from '~/vcl/icons/Weight';
import ProductCustomIcon from '~/jobiqo/components/Job/Wizard/components/ProductCustomIcon';

/**
 * @file upgrdesIcons.tsx
 *
 * @fileoverview Helper method to return an icon for eaach upgrade based on id.
 */
export const getJobUpradeIcon = (
  icon,
  iconCustom: Maybe<Image> | undefined = undefined,
) => {
  // If the custom icon is provided, render it before any other predefined icon.
  if (iconCustom) {
    return <ProductCustomIcon iconCustom={iconCustom} width={48} height={48} />;
  }
  switch (icon) {
    case 'graduation':
      return <GraduationCapIcon title={icon} />;
    case 'office':
      return <OfficeIcon title={icon} />;
    case 'payment':
      return <PaymentIcon title={icon} />;
    case 'lock':
      return <LockIcon title={icon} />;
    case 'envelope':
      return <EnvelopeIcon title={icon} />;
    case 'filters':
      return <FiltersIcon title={icon} />;
    case 'cards':
      return <CreditCardIcon title={icon} />;
    case 'clock':
      return <ClockIcon title={icon} />;
    case 'analytics':
      return <LaptopAnalyticsIcon title={icon} />;
    case 'file':
      return <JobPerFileIcon title={icon} />;
    case 'template':
      return <JobPerTemplateIcon title={icon} />;
    case 'exit':
      return <ExitIcon title={icon} />;
    case 'download':
      return <DownloadIcon title={icon} />;
    case 'connection':
      return <ConnectionNetworkIcon title={icon} />;
    case 'map_marker':
      return <MapMarkerIcon title={icon} />;
    case 'marker':
      return <MarkerIcon title={icon} />;
    case 'video':
      return <VideoGalleryIcon title={icon} />;
    case 'weight':
      return <WeightIcon title={icon} />;
    case 'star':
      return <StarIcon title={icon} />;
    case 'resume_lock':
      return <ResumeLockIcon title={icon} />;
    case 'network':
      return <NetworkIcon title={icon} />;
    case 'chart':
      return <ChartIcon title={icon} />;
    case 'explore':
      return <ExploreIcon title={icon} />;
    case 'info':
      return <InfoIcon title={icon} />;
    case 'badge':
      return <BadgeIcon title={icon} />;
    case 'briefcase':
      return <BriefcaseIcon title={icon} />;
    case 'calendar':
      return <CalendarIcon title={icon} />;
    default:
      return <RocketIcon title={icon} />;
  }
};
